/* Source: captured _pf_handleLazyLoadBackgroundImage in pagefly-general-helper.js.
 * Namespace only. Each article retains its original lazy-background marker.
 */
(function installDedicatedArticleBackground() {
  'use strict';
  if (window.NativeDedicatedArticleBackground) return;
  const selector = '.np-dedicated-bg-lazy';
  const marker = 'np-dedicated-bg-lazy';
  function elements(root) {
    const list = Array.from(root.querySelectorAll(selector));
    if (typeof root.matches === 'function' && root.matches(selector)) list.unshift(root);
    return list;
  }
  function init(root = document) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    window.setTimeout(function initializeObserver() {
      if ('IntersectionObserver' in window) {
        const observer = new window.IntersectionObserver(function reveal(entries) {
          entries.forEach(function onEntry(entry) {
            if (entry.isIntersecting) {
              entry.target.classList.remove(marker);
              observer.unobserve(entry.target);
            }
          });
        }, {rootMargin: '5%'});
        elements(root).forEach(element => observer.observe(element));
      } else {
        window.setTimeout(function noObserverFallback() {
          elements(root).forEach(element => element.classList.remove(marker));
        }, 3000);
      }
    });
    window.setTimeout(function maximumDelayFallback() {
      elements(root).forEach(element => element.classList.remove(marker));
    }, 10000);
  }
  window.NativeDedicatedArticleBackground = {init};
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  } else {
    init(document);
  }
})();
